// eslint-disable-next-line import/prefer-default-export
/* eslint-disable quote-props */

export const CONTACT_TYPE_VALUES = [
  'Party Guest',
  'Group Member',
  'Customer',
  'Personal Teammate',
  'Downline (Not Personal)',
];

export const CUSTOMER_NEW_EXISTING_TYPE_VALUES = [
  'New Customer',
  'Existing Customer',
];

export const CUSTOMER_ORDERED_VALUES = [
  'Ordered',
  'Has Not Ordered',
];

export const FORM_CONTACT_TYPES = {
  REGULAR: 'regular',
  PARTY_GUEST: 'partyGuest',
  GROUP_MEMBER: 'groupMember',
};

export const ACTIONS_VALUES_AND_LABELS = {
  [FORM_CONTACT_TYPES.PARTY_GUEST]: {
    action3: {
      'Y': 'Booked an Event off of This Event',
      'N': 'Has Not Booked an Event off of This Event',
      'M': 'Maybe Booking an Event off of This Event',
      'Said No': 'Said No to Booking an Event off of This Event',
    },
    action4: {
      'Y': 'Joining as a Consultant off of This Event',
      'N': 'Has Not Joined as a Consultant off Of This Event',
      'M': 'Maybe Joining as a Consultant off of This Event',
      'Said No': 'Said No to Joining as a Consultant off of This Event',
    }
  },
  [FORM_CONTACT_TYPES.GROUP_MEMBER]: {
    action3: {
      'Y': 'Booked an Event from This Group',
      'N': 'Has Not Booked an Event from This Group',
      'M': 'Maybe Booking an Event from This Group',
      'Said No': 'Said No to Booking an Event from This Group',
    },
    action4: {
      'Y': 'Joining as a Consultant from This Group',
      'N': 'Has Not Joined as a Consultant from This Group',
      'M': 'Maybe Joining as a Consultant from This Group',
      'Said No': 'Said No to Joining as a Consultant from This Group',
    }
  }
};

// Mirrors server/constants/contacts.js — keep the two files in sync.
export const BOOKED_EVENT_SCREEN_OPTIONS = {
  NOT_BOOKED: 'Has Not Booked',
  NO_TO_BOOKING: 'Said No to Booking',
  MAYBE_BOOKING: 'Maybe Booking',
  BOOKED: 'Booked an Event',
};

export const BOOKED_EVENT_DB_OPTIONS = {
  NOT_BOOKED: 'N',
  NO_TO_BOOKING: 'Said No',
  MAYBE_BOOKING: 'M',
  BOOKED: 'Y',
};

export const JOIN_AS_CONSULTANT_SCREEN_OPTIONS = {
  NOT_JOINED: 'Has Not Joined',
  NO_TO_JOINING: 'Said No to Joining',
  MAYBE_JOINING: 'Maybe Joining',
  JOINED: 'Joined as Consultant',
};

export const JOIN_AS_CONSULTANT_DB_OPTIONS = {
  NOT_JOINED: 'N',
  NO_TO_JOINING: 'Said No',
  MAYBE_JOINING: 'M',
  JOINED: 'Y',
};

export const CONTACT_MODAL_FORM_NAMES = {
  MODAL_SELECT_NUMBER_TO_CALL: 'ModalSelectNumberToCall',
  MODAL_CALLING_YOU_TO_CONNECT_YOU_WITH: 'ModalCallingYouToConnectYouWith',
};
